import { useState } from "react";
import { X } from "lucide-react";
import { PALETTES, setPalette, usePalette } from "@/lib/theme";

const LABELS = { white: "Bianco originale", panna: "Sabbia & salvia", sage: "Salvia & noce" };
const SWATCH = { white: ["#FFFFFF", "#F1ECE3", "#C26D38", "#121110"], panna: ["#FFFFFF", "#D5C7AD", "#8A8E75", "#68604D"], sage: ["#FFFFFF", "#9CAF88", "#5A3E2B", "#9A6B45"] };

// Hidden palette comparison: shown only after opening the site with ?palette (see lib/theme.js).
export const PaletteSwitch = () => {
  const current = usePalette();
  const [show, setShow] = useState(() => localStorage.getItem("emma-palette-ui") === "1");
  if (!show) return null;
  const hide = () => { localStorage.removeItem("emma-palette-ui"); setShow(false); };
  return (
    <div className="keep-dark fixed bottom-24 left-4 z-[60] flex items-center gap-1 rounded-full border border-black/10 bg-[#1C1A14]/90 p-1.5 text-[#F1EAD8] shadow-xl backdrop-blur-md" data-testid="palette-switch">
      {PALETTES.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => setPalette(p)}
          aria-pressed={current === p}
          className={`flex items-center gap-2 rounded-full px-3 py-2 font-mono text-xs uppercase tracking-[0.12em] transition-[background-color,color] duration-300 ${current === p ? "bg-[#F1EAD8] text-[#1C1A14]" : "hover:bg-white/10"}`}
          data-testid={`palette-switch-${p}`}
        >
          <span className="flex -space-x-1">
            {SWATCH[p].map((c) => <span key={c} className="h-3.5 w-3.5 rounded-full border border-black/20" style={{ background: c }} />)}
          </span>
          <span className="max-sm:sr-only">{LABELS[p]}</span>
        </button>
      ))}
      <button type="button" onClick={hide} aria-label="Nascondi selettore" className="grid h-8 w-8 place-items-center rounded-full transition-colors duration-300 hover:bg-white/10" data-testid="palette-switch-close">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
